export const supportActionTypes = {
  RESET: 'support/RESET',
  SUPPORT_SUCCESS: 'support/SUPPORT_SUCCESS',
};
